import { useContext, useEffect, useRef } from 'react';
import Checkbox from '@/FiltersMenu/Checkbox';
import AppliedFiltersContext from '~/contexts/AppliedFiltersContext';
import InventoryContext from '~/contexts/InventoryContext';
import LabelWithCount from '../LabelWithCount';

type OwnProps = {
  count: number;
  make: string;
  model: string;
  showCount?: boolean;
};

const Model = ({ count, make, model, showCount }: OwnProps) => {
  const { appliedFilters, updateMakes } = useContext(AppliedFiltersContext);
  const {
    inventory: { isLoaded }
  } = useContext(InventoryContext);
  const showModelCountRef = useRef(showCount);

  const appliedMakes = appliedFilters?.makes?.find(
    appliedMake => appliedMake.name === make
  );

  const isSelected = appliedMakes?.models?.some(
    appliedModel => appliedModel.name === model
  );

  useEffect(() => {
    if (isLoaded) {
      showModelCountRef.current = true;
    }
  }, [isLoaded]);

  useEffect(() => {
    if (!showCount) {
      showModelCountRef.current = false;
    }
  }, [showCount]);

  return (
    <Checkbox
      facet="models"
      filter={model}
      id={`model-${model}`}
      checked={isSelected}
      onChange={() => updateMakes({ name: model, parents: [make] })}
      label={
        <LabelWithCount
          count={count}
          displayName={model}
          showCount={showModelCountRef.current}
        />
      }
    />
  );
};

export default Model;
